import { useMemo } from 'react';
import {
  countSignalsByAiAssetKind,
  type AiSignalsAssetKindProfile,
} from '@terra/ui-ai-applications';
import { useAiApplicationComponents } from './api/useAiApplicationComponents';
import {
  useAiComponentSignalCounts,
  type AiComponentSignalCountsFilters,
} from './api/useAiComponentSignalCounts';

export const useAiSignalsKindCounts = ({
  targetId,
  isAiApplication,
  endpointId,
  profile,
  filters,
}: {
  targetId?: string;
  isAiApplication: boolean;
  endpointId?: string;
  profile: AiSignalsAssetKindProfile;
  filters: AiComponentSignalCountsFilters;
}) => {
  const isEnabled = isAiApplication && Boolean(targetId);
  const applicationId = isAiApplication ? (targetId ?? null) : null;

  const endpointIds = useMemo(
    () => (endpointId ? [endpointId] : undefined),
    [endpointId],
  );

  const { components } = useAiApplicationComponents({
    aiApplicationId: applicationId,
    enabled: isEnabled,
  });

  const { signalCountsByComponentId } = useAiComponentSignalCounts({
    applicationId,
    endpointIds,
    filters,
    enabled: isEnabled,
  });

  return useMemo(
    () =>
      countSignalsByAiAssetKind({
        components,
        countsByAssetId: signalCountsByComponentId,
        profile,
      }),
    [components, profile, signalCountsByComponentId],
  );
};
